import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { I18nextProvider } from 'react-i18next'
import i18nConfig from './i18n/i18n'
import App from './App'
import reportWebVitals from './reportWebVitals'

import 'semantic-ui-css/semantic.min.css'
ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18nConfig}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
